<template>
  <v-dialog v-model="show" persistent lazy max-width="600">
    <v-card>
      <v-card-title class="title">Загрузка документов</v-card-title>
      <v-card-text>
        <v-progress-linear v-model="progress"></v-progress-linear>
        <v-layout align-center justify-space-around row>
          <v-flex>
            {{ file_name }}
          </v-flex>
          <v-flex class="text-xs-right">
            Загружено: {{ prettyBytes(current_size) }} / {{ prettyBytes(total_size) }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="done" color="green" flat @click="onUploaded()">Готово</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import prettyBytes from 'pretty-bytes'

export default {
  name: 'DocumentUploadProgressDialog',
  props: ['value', 'files'],
  data () {
    return {
      current_size: 0,
      total_size: 0,
      file_name: '',
      done: false
    }
  },
  methods: {
    async triggerUpload () {
      for (let i = 0; i < this.files.length; i++) {
        this.total_size += this.files[i].size
      }

      for (let i = 0; i < this.files.length; i++) {
        let fd = new FormData()
        let file = this.files[i]
        fd.append('document', file)
        fd.append('is_shared', false)
        this.file_name = `Загрузка: ${file.name}`
        await this.$store.dispatch('postDocument', fd)
        this.current_size += file.size
      }

      this.done = true
    },
    prettyBytes(size) {
      return prettyBytes(size)
    },
    onUploaded () {
      this.show = false
      this.$router.push({ name: 'pending_document_list' })
      this.$store.dispatch('getDocumentList', {mode: 'pending'})
    },
    onClose () {
      this.current_size = 0
      this.total_size = 0
      this.file_name = ''
      this.done = false
    }
  },
  watch: {
    files: 'triggerUpload',
  },
  created () {
    this.$on('close', this.onClose)
  },
  computed: {
    progress () {
      return this.current_size*100/this.total_size
    },
    show: {
      get () {
        return this.value
      },
      set (newValue) {
        if (!newValue) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>
